/* eslint-disable react/no-did-update-set-state */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import moment from "moment";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
  MDBListGroup,
  MDBListGroupItem,
  MDBSpinner
} from "mdbreact";
import PKHBtn from "~/components/common/atoms/Button";
import TagName from "~/components/common/atoms/TagName";
import {
  checkFollowUpExam,
  resetStatucChecking,
  clearListFollowUpExam
} from "~/store/followUpExam/actions";
import styles from "./style.module.scss";
import querystring from "query-string";

class FollowUpExamGetInfoByPhone extends Component {
  constructor(props) {
    super(props);
    const query = querystring.parse(window.location.search);
    this.state = {
      phone: query.phone || "",
      error: "",
      loading: false
    };
  }

  onChangePhone = e => {
    const { isCheck } = this.props;
    const patternMobile = /^[0-9]*$/;
    let value = e.target.value;
    if (patternMobile.test(value)) {
      this.setState({
        phone: value
      });
    } else {
      value = value.slice(-1, 1);
    }

    // nếu đã tìm kiếm ko thấy, khi thay đổi số đt sẽ reset
    if (isCheck) {
      this.props.resetStatucChecking();
    }
  };

  handleCheckScheduleReexam = () => {
    const { phone } = this.state;
    // call action
    this.props.checkFollowUpExam(phone);
  };

  renderListReExam = data => {
    return data.map((item, index) => {
      const {
        patientDetail: {
          patientLastName,
          patientFirstName,
          patientBirthYear,
          patientBirthDay
        },
        quickBookingUrl,
        scheduleDate,
        subject: { name: subjectName }
      } = item;

      const fullName = `${patientLastName} ${patientFirstName}`;
      const birthdate = patientBirthDay
        ? moment(patientBirthDay).format("DD/MM/YYYY")
        : patientBirthYear;

      const scheduleExam = moment(scheduleDate).format("DD/MM/YYYY");
      return (
        <Fragment key={index}>
          <MDBCard
            className={styles.item_reexam}
            onClick={() => {
              window.location.href = quickBookingUrl;
              // window.location.href = `http://localhost:3000/reexam/bd27611a623346c4b6c38f`;
            }}
          >
            <MDBListGroup className={styles.list_group}>
              <MDBListGroupItem>
                <div className={styles.fullname}>
                  <i className="fal fa-user-circle" />
                  <strong>{fullName}</strong>
                </div>
              </MDBListGroupItem>

              <MDBListGroupItem>
                <div className={styles.column1}>
                  <i className="fal fa-birthday-cake" />
                  Ngày sinh: {birthdate}
                </div>
              </MDBListGroupItem>

              <MDBListGroupItem>
                <div className={styles.column1}>
                  <i className="fal fa-building" />
                  Chuyên khoa: {subjectName}
                </div>
              </MDBListGroupItem>
              <MDBListGroupItem>
                <div className={styles.column1}>
                  <i className="fal fa-calendar-alt" />
                  Ngày tái khám: {scheduleExam}
                </div>
              </MDBListGroupItem>
            </MDBListGroup>
          </MDBCard>
        </Fragment>
      );
    });
  };

  renderResult = list => {
    const { isCheck } = this.props;
    if (list.length) {
      return (
        <div className={styles.list_exam}>
          <div className={styles.title}>Kết quả tìm kiếm</div>
          {this.renderListReExam(list)}
        </div>
      );
    } else {
      if (isCheck) {
        return (
          <div className={styles.list_exam}>
            <div className={styles.title}>Không tìm thấy thông tin</div>
          </div>
        );
      } else {
        return "";
      }
    }
  };

  componentDidMount() {
    // reset lich tai kham cu
    this.props.clearListFollowUpExam();
    // reset trạng thái kết quả tìm kiếm
    this.props.resetStatucChecking();
    // check nếu trên url có param phone thì check lịch tái khám
    if (this.state.phone !== "") {
      this.setState({ loading: true });
      this.handleCheckScheduleReexam();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { listReExam } = this.props;
    if (listReExam.length === 1) {
      window.location.href = listReExam[0].quickBookingUrl;
    } else {
      if (prevState.loading) this.setState({ loading: false });
    }
  }

  render() {
    // console.log(window.path);
    // console.log(this.state.loading);
    const { listReExam } = this.props;
    if (this.state.loading)
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    return (
      <MDBContainer className={cx(["mt-5"])}>
        <MDBRow className="row_mobile">
          <MDBCol md="12" lg="12">
            <div className={cx(styles.wrapper_card)}>
              <MDBCard
                className={cx(
                  styles.panels,
                  styles.panel_mobile,
                  styles.card_element
                )}
              >
                <MDBCardHeader className={styles.panels_header}>
                  <TagName
                    element="h2"
                    className={[
                      "title_component",
                      "title_choose_date",
                      "justify_center",
                      "title_header_mobile"
                    ]}
                  >
                    <span>
                      Vui lòng nhập số điện thoại để tiếp tục quá trình tái khám
                    </span>
                  </TagName>
                </MDBCardHeader>
                <MDBCardBody className={[styles.card_body]}>
                  <div className={[styles.card_content]}>
                    <input
                      type="text"
                      id="example1"
                      placeholder="Nhập số điện thoại"
                      className="form-control form-control-lg"
                      value={this.state.phone}
                      onChange={e => this.onChangePhone(e)}
                      onKeyDown={event => {
                        if (event.keyCode === 13) {
                          event.preventDefault();
                          this.handleCheckScheduleReexam();
                        }
                      }}
                    />
                    <PKHBtn
                      color="primary"
                      create="create"
                      block="block"
                      onClick={this.handleCheckScheduleReexam}
                    >
                      Tìm kiếm
                    </PKHBtn>
                  </div>
                  {this.renderResult(listReExam)}
                </MDBCardBody>
              </MDBCard>
              <div ref={this.scrollToDiv} />
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    );
  }
}

const mapStateToProps = state => {
  const {
    followUpExam: { listReExam, isCheck }
  } = state;
  return {
    listReExam,
    isCheck
  };
};

export default connect(mapStateToProps, {
  checkFollowUpExam,
  resetStatucChecking,
  clearListFollowUpExam
})(FollowUpExamGetInfoByPhone);
